import Vue from "vue"

import resetMixin from "~/mixins/store/resetToInitialState"

const initialState = function () {
  return {
    cart_id: 0,
    influencer_ids: [],
  }
}

export const state = initialState

export const mutations = {
  SET_ID: function (state, id) {
    state.cart_id = id
  },
  SET_INFLUENCERS: function (state, influencer_ids) {
    state.influencer_ids.splice(
      0,
      state.influencer_ids.length,
      ...influencer_ids
    )
  },
  ADD_INFLUENCER_ARRAY: function (state, influencer_id_array) {
    state.influencer_ids.unshift(
      ...influencer_id_array.filter((e) => !state.influencer_ids.includes(e))
    )
  },
  REMOVE_INFLUENCER_ARRAY: function (state, influencer_id_array) {
    Vue.set(
      state,
      "influencer_ids",
      state.influencer_ids.filter((e) => !influencer_id_array.includes(e))
    )
  },
  ...resetMixin.mutations,
}

export const actions = {
  RESET: function ({ commit }) {
    commit("RESET", initialState())
  },
  CLEAN: function ({ state, rootGetters, dispatch }) {
    const batch = state.influencer_ids.filter((id) => {
      return rootGetters["influencers/IDS"].includes(id)
    })

    if (batch.length) dispatch("REMOVE_INFLUENCER_ARRAY", batch)
  },
  EMPTY: function ({ dispatch, getters }) {
    return dispatch("REMOVE_INF", getters.INFLUENCERS)
  },
  DELETE: function ({ dispatch, state }) {
    return new Promise((resolve, reject) => {
      if (state.cart_id) {
        this.$axios
          .$delete(`/submission/cart/${state.cart_id}/`, {
            headers: { "X-CSRFToken": this.$cookies.get("csrftoken") },
          })
          .then(() => {
            resolve(dispatch("RESET"))
          })
          .catch((err) => {
            reject(err)
          })
      } else resolve(true)
    })
  },
  FETCH: function ({ commit, getters, state, rootState, rootGetters }) {
    return new Promise((resolve, reject) => {
      if (
        !state.cart_id &&
        !getters.HAS_DRAFT &&
        (rootGetters["user/IS_BAND"] ? rootState.user.band.id > 0 : true) &&
        !rootGetters["user/IS_INF"]
      ) {
        this.$axios
          .$get("/submission/cart/", {
            headers: { "X-CSRFToken": this.$cookies.get("csrftoken") },
          })
          .then((carts) => {
            if (carts.length) {
              commit("SET_ID", carts[0].id)
              commit("SET_INFLUENCERS", carts[0].influencers)
              resolve(carts[0])
            } else resolve(null)
          })
          .catch((err) => {
            reject(err)
          })
      } else resolve(null)
    })
  },
  ADD_INF: function ({ commit, getters, rootState }, bundle) {
    return new Promise((resolve, reject) => {
      if (typeof bundle === "number") bundle = [bundle]
      if (bundle.length) {
        this.$axios
          .$post("/submission/draft/add/", {
            influencers: bundle,
            draft: getters.HAS_DRAFT ? rootState.draft.id : undefined,
          })
          .then(() => {
            if (!getters.HAS_DRAFT) commit("ADD_INFLUENCER_ARRAY", bundle)
            else commit("draft/ADD_INFLUENCER_ARRAY", bundle, { root: true })
            resolve(bundle)
          })
          .catch((err) => {
            reject(err)
          })
      } else resolve([])
    })
  },
  REMOVE_INF: function ({ commit, getters, rootState }, bundle) {
    return new Promise((resolve, reject) => {
      if (typeof bundle === "number") bundle = [bundle]
      if (bundle.length) {
        this.$axios
          .$post("/submission/draft/remove/", {
            influencers: bundle,
            draft: getters.HAS_DRAFT ? rootState.draft.id : undefined,
          })
          .then(() => {
            if (!getters.HAS_DRAFT) commit("REMOVE_INFLUENCER_ARRAY", bundle)
            else commit("draft/REMOVE_INFLUENCER_ARRAY", bundle, { root: true })
            resolve(bundle)
          })
          .catch((err) => {
            reject(err)
          })
      } else resolve([])
    })
  },
  FETCH_MISSING_INFLUENCERS: function ({
    state,
    getters,
    dispatch,
    rootGetters,
  }) {
    if (getters.HAS_DRAFT)
      return dispatch("draft/FETCH_MISSING_INFLUENCERS", null, { root: true })
    else
      return new Promise((resolve, reject) => {
        const missing_influencer_ids = state.influencer_ids.filter(
          (influencer_id) => {
            return !rootGetters["influencers/ID_EXISTS"](influencer_id)
          }
        )

        if (missing_influencer_ids.length) {
          dispatch("influencers/FETCH_SET", missing_influencer_ids, {
            root: true,
          })
            .then(() => {
              resolve(true)
            })
            .catch((err) => {
              reject(err)
            })
        } else resolve(true)
      })
  },
}

export const getters = {
  HAS_DRAFT: function (state, getters, rootState, rootGetters) {
    return rootState.draft.id > 0
  },
  INFLUENCERS: function (state, getters, rootState) {
    if (!getters.HAS_DRAFT) return state.influencer_ids
    else return rootState.draft.influencers
  },
  INF_ID_IS_IN: function (state, getters) {
    return function (influencer_id) {
      return getters.INFLUENCERS.includes(influencer_id)
    }
  },
  COST: function (state, getters, rootState, rootGetters) {
    return getters["INFLUENCERS"].reduce(function (accumulator, element) {
      const cost = rootGetters["influencers/GET_BY_ID"](element)?.cost ?? 0

      if (cost) return accumulator + Number(cost)
      else return accumulator
    }, 0)
  },
}
